<template>
  <div
    class="app-alert"
    :class="[
      outlined ? 'app-alert__border-positive' : null,
      `bg-${variant}`,
      rounded ? 'app-alert__rounded' : null,
    ]"
  >
    <p class="text-bold">
      <slot name="title" />
    </p>
    <p
      :class="[bold ? 'text-bold' : null]"
      class="flex items-center justify-center q-gutter-x-xs"
    >
      <slot name="icon" />
      <span style="margin-left:10px">
        <slot />
      </span>
    </p>
  </div>
</template>

<script>
export default {
  name: "AppAlert",
  props: {
    variant: {
      type: String,
      required: true,
      default: "", // success || danger || warning
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    bold: {
      type: Boolean,
      default: false,
    },
    rounded: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style lang="less">
.app-alert {
  padding: 0.625rem; // 10px
  &__rounded {
    border-radius: 0.25rem !important; // 4px
  }
  &__border-positive {
    border: 1px solid #ed6c10 !important;
  }
  p {
    text-align: center;
    font-size: clamp(12px, 1vw, 16px);
  }
}
</style>
